/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerArchiveMutationRequest,
  TelegramProductsUserControllerArchiveMutationResponse,
  TelegramProductsUserControllerArchive401,
} from '../types/TelegramProductsUserControllerArchive.ts';

function getTelegramProductsUserArchiveUrl() {
  const res = { method: 'PATCH', url: `/api/user/telegram/products/archive` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/archive}
 */
export async function telegramProductsUserArchive(
  data: TelegramProductsUserControllerArchiveMutationRequest,
  config: Partial<RequestConfig<TelegramProductsUserControllerArchiveMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramProductsUserControllerArchiveMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerArchive401>,
    TelegramProductsUserControllerArchiveMutationRequest
  >({ method: 'PATCH', url: getTelegramProductsUserArchiveUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
